import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import Seo from '../utils/Seo';
import BookSection from './BookSection';
import Book from '../assets/images/homepage/book.png';
import MainImage from '../assets/images/events/events_main01.jpg';
import Thumb1 from '../assets/images/events/events_thumb1.jpg';
import Thumb2 from '../assets/images/events/events_thumb2.jpg';
import Thumb3 from '../assets/images/events/events_thumb3.jpg';
import Thumb4 from '../assets/images/events/events_thumb4.jpg';
import Glyph from '../assets/images/layout/glyph_left_light.png';
import MainLogo from '../assets/images/layout/nochedemuertos_pos_800.png'
import '../css/events.css';
import Testimonials from './Testimonials';
import Autores from './Autores';

export default function Eventos() {

    const location = useLocation();

    const queryParams = new URLSearchParams(location.search);

    // Default text
    const defaultText = 'Si estás aquí, ya eres parte de esta historia.';

    // Determine the text to display based on query parameters
    let displayText = defaultText;

    if (queryParams.toString()) {
        queryParams.forEach((value, key) => {
            if (key === 'valentina') {
                displayText = '¡Bienvenida Valentina!';
            }
            else if (key === 'espejo') {
                displayText = 'Espejo';
            }
            else if (key === 'taquito') {
                displayText = '¡Bienvenido Taquito!';
            }
            else if (key === 'camazotz') {
                displayText = 'Camazotz';
            }
            else if (key === 'tinskani') {
                displayText = '¡Bienvenida Tinskani!';
            }
            else if (key === 'choc') {
                displayText = '¡Bienvenida Choc!';
            }
            else if (key === 'mictlan') {
                displayText = 'Mictlán';
            }
            else if (key === 'ofrenda') {
                displayText = 'Ofrenda';
            }
        });
    }

    return (
        <div className="mainMargin-close">
            <Seo
                title="Próximos eventos de Noche de Muertos | Día de la Vida"
                description="Descubre la aventura de Valentina en el Día de Muertos."
            />
            <div id="events_top">
                <div className="container">
                    <div className="row g-0">
                        <div className="col-md-5 order-md-2 order-1">
                            <img src={MainLogo} alt="Noche de Muertos" className='main_logo img-fluid align-self-start' />
                        </div>
                        <div className="col-md-7 order-md-1 order-2">
                            <img src={MainImage} alt="Noche de Muertos" className='main_image img-fluid align-self-end' />
                        </div>
                    </div>
                </div>
            </div>

            <div id="events_message" className='events_padding'>
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            {displayText}
                        </div>
                    </div>
                </div>
            </div>

            <div id="events_images">
                <div className="container">
                    <div className="row g-0">
                        <div className="image col-6 col-md-3" style={{ backgroundImage: `url(${Thumb1})`, backgroundPosition: 'left' }}>
                        </div>
                        <div className="image col-6 col-md-3" style={{ backgroundImage: `url(${Thumb2})`, backgroundPosition: 'center' }}>
                        </div>
                        <div className="image col-6 col-md-3" style={{ backgroundImage: `url(${Thumb3})`, backgroundPosition: 'center' }}>
                        </div>
                        <div className="image col-6 col-md-3" style={{ backgroundImage: `url(${Thumb4})`, backgroundPosition: 'right' }}>
                        </div>
                    </div>
                </div>
            </div>

            <div id="events_abstract" className="events_padding">
                <div className="container">
                    <div className="row">
                        <div className="col-md-3 abstract_image">
                            <img src={Glyph} alt="Glyph" />
                        </div>
                        <div className="col-md-9">
                            <h4>Valentina solo esperaba pasar una Noche de Muertos tranquila con su familia en Tzintzuntzan...</h4>
                            <p>Un inesperado giro del destino arrastra a Valentina a una aventura más allá de lo imaginable, cayendo en el vibrante y peligroso inframundo.</p>
                            <p>En este mundo subterráneo, Valentina tendrá que aprender a sobrevivir mientras se encuentra con seres legendarios de la mitología mexicana. Con la ayuda de Taquito, el xoloitzcuintle de la familia  y la enigmática investigadora Tinskani, navegará por las maravillas y los peligros del Comiehchúcuaro y el Mictlán. Descubrirá secretos ancestrales y la profunda conexión entre el mundo de los vivos y el de los muertos.</p>
                            <p>La misión más importante será regresar a casa, mientras es perseguida por temibles y antiguos peligros. En este viaje lleno de magia y peligros, Valentina no solo pondrá a prueba su valentía y aprenderá a controlar sus emociones, sino que también entenderá que sus raíces purépechas y el amor incondicional de su familia son su mayor fortaleza.</p>
                            <p><b>¡Prepárate para un viaje que transformará todo lo que crees saber sobre la vida, la muerte y quién eres realmente! Descubre cómo la tradición más colorida de México se convierte en la aventura de una vida... ¡y quizás del más allá!</b></p>
                        </div>
                    </div>
                </div>
            </div>

            <div id="events_calendar" className="events_padding">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <h2>¡La aventura comienza ahora!</h2>
                            <h4>Calendario de eventos 2025-2026</h4>
                            <p>¡Estamos muy contentos de compartir estos primeros pasos de Valentina contigo!</p>
                            <p>En esta sección podrás encontrar todos los eventos que tenemos planeados para que conozcas un poco más sobre el libro, sus autores y todas las personas que lo hicieron posible. Regresa a esta sección con frecuencia, nunca sabes que nueva sorpresa puede haber cerca de ti ;)</p>
                        </div>
                    </div>
                    <div className="event row align-items-start">
                        <div className="col-md-1">
                            <div className="date">01/02 Nov</div>
                        </div>
                        <div className="col-md-9">
                            <div className="data">
                                <h5>Mi Tierra en La Villita (2528 S Kedzie Ave, Chicago, IL 60623)</h5>
                                <p><b>Lanzamiento del libro Noche de Muertos / Día de la Vida con Said Jiménez</b>, como parte de la 1era Emisión Celebra la Herencia Mexicana en Chicago con Arte, Literatura y Comunidad en el Día de Muertos.</p>
                                <p>Te invitamos a ser parte de esta celebración, donde podrás conocer a artistas emergentes y fortalecer los lazos de nuestra comunidad. ¡No te lo pierdas! ¡Aparta tu lugar!</p>
                            </div>
                        </div>
                        <div className="col-md-2">
                            <a href="https://wa.me/525551079711?text=Me%20gustaría%20asistir%20al%20evento%20de%20Noche%20de%20Muertos%20/%20Día%20de%20la%20Vida%20en%20Chicago" target='_blank' rel="noopener noreferrer" className="text-decoration-none">
                                <div className="status">
                                    <span className="badge bg-success">Disponible</span><br />
                                    <small className="text-muted">Haz clic para reservar</small>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div className="event row align-items-center">
                        <div className="col-md-1">
                            <div className="date">02 Nov<br /><small>11:00 hrs</small></div>
                        </div>
                        <div className="col-md-9">
                            <div className="data">
                                <h5>Fundación Nancy Cárdenaz Martínez (Av. Col del Valle 609 Col. Del Valle, CDMX)</h5>
                                <p><b>Lanzamiento del libro Noche de Muertos / Día de la Vida con Balam Tzibtah</b>, con tranmisión en vivo al lanzamiento en Chicago</p>
                                <p>Te invitamos a ser parte de esta celebración, donde además podrás disfrutar de instalaciones de arte. ¡No te lo pierdas! ¡Aparta tu lugar!</p>
                            </div>
                        </div>
                        <div className="col-md-2">
                            {/* <div className="status">
                                <span className="badge bg-warning">¡Cupo lleno!</span>
                            </div> */}
                            <a href="https://wa.me/525551079711?text=Me%20gustaría%20asistir%20al%20evento%20de%20Noche%20de%20Muertos%20/%20Día%20de%20la%20Vida%20en%20CDMX" target='_blank' rel="noopener noreferrer" className="text-decoration-none">
                                <div className="status">
                                    <span className="badge bg-success">Disponible</span><br />
                                    <small className="text-muted">Haz clic para reservar</small>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div id="events_book">
                <BookSection
        title="¿Ya conoces mi libro?"
        description="¡Si quieren saber cómo una chava normal como yo se aventó un viaje re loco, conociendo personajes alucinantes y descubriendo que era más valiente de lo que creía, entonces ESTA es la historia que necesitas leer! ¡Te juro que no te vas a arrepentir!"
        imgSrc={Book}
        linkText="Lo puedes comprar aquí"
        linkTo="https://wa.me/525551079711?text=Me%20gustar%C3%ADa%20adquirir%20el%20libro%20de%20Noche%20de%20Muertos%20/%20D%C3%ADa%20de%20la%20Vida"
      />
            </div>

            <div id='events_authors' className='double_glyph events_padding'>
                <div className="container">
                    { <Autores /> }
                </div>
            </div>

            <div>
                {/* <Testimonials /> */}
            </div>
        </div>
    );
}